import { create } from 'zustand';

export interface GpsFix {
  lat: number;
  lon: number;
  altMeters?: number | null;
  speedMps?: number | null;
  headingDeg?: number | null;
  accuracyM?: number | null;
  timestamp: number;
}

interface GpsState {
  fix: GpsFix | null;
  watching: boolean;
  error: string | null;
  watchId: number | null;
  start: () => void;
  stop: () => void;
}

export const useGpsStore = create<GpsState>((set, get) => ({
  fix: null,
  watching: false,
  error: null,
  watchId: null,

  start: () => {
    if (get().watching) return;
    if (!('geolocation' in navigator)) {
      set({ error: 'Geolocation not available' });
      return;
    }
    const id = navigator.geolocation.watchPosition(
      (pos) => {
        set({
          fix: {
            lat: pos.coords.latitude,
            lon: pos.coords.longitude,
            altMeters: pos.coords.altitude,
            speedMps: pos.coords.speed,
            headingDeg: pos.coords.heading,
            accuracyM: pos.coords.accuracy,
            timestamp: pos.timestamp,
          },
          error: null,
        });
      },
      (err) => set({ error: err.message }),
      { enableHighAccuracy: true, maximumAge: 1000, timeout: 15000 }
    );
    set({ watching: true, watchId: id });
  },

  stop: () => {
    const id = get().watchId;
    if (id != null) navigator.geolocation.clearWatch(id);
    set({ watching: false, watchId: null });
  },
}));
